import * as Types from '@trello/graphql/generated';

import DocumentNode from '@trello/graphql/src/documentNode';
import * as Apollo from '@apollo/client';
export const DeletePluginDocument = {"kind":"Document","definitions":[{"kind":"OperationDefinition","operation":"mutation","name":{"kind":"Name","value":"DeletePlugin"},"variableDefinitions":[{"kind":"VariableDefinition","variable":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}},"type":{"kind":"NonNullType","type":{"kind":"NamedType","name":{"kind":"Name","value":"ID"}}}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"deletePlugin"},"arguments":[{"kind":"Argument","name":{"kind":"Name","value":"pluginId"},"value":{"kind":"Variable","name":{"kind":"Name","value":"idPlugin"}}}],"directives":[{"kind":"Directive","name":{"kind":"Name","value":"client"}}],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"success"}}]}}]}}]} as unknown as DocumentNode;
const defaultOptions = {"context":{"operationName":"DeletePlugin","document":DeletePluginDocument}} as const;
export type DeletePluginMutationVariables = Types.Exact<{
  idPlugin: Types.Scalars['ID']['input'];
}>;


export type DeletePluginMutation = (
  { __typename: 'Mutation' }
  & { deletePlugin?: Types.Maybe<(
    { __typename: 'Plugin_DeleteResponse' }
    & Pick<Types.Plugin_DeleteResponse, 'success'>
  )> }
);

export type DeletePluginMutationFn = Apollo.MutationFunction<
  DeletePluginMutation,
  DeletePluginMutationVariables
>;

/**
 * __useDeletePluginMutation__
 *
 * To run a mutation, you first call `useDeletePluginMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useDeletePluginMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [deletePluginMutation, { data, loading, error }] = useDeletePluginMutation({
 *   variables: {
 *      idPlugin: // value for 'idPlugin'
 *   },
 * });
 */
export function useDeletePluginMutation(
  baseOptions?: Apollo.MutationHookOptions<
    DeletePluginMutation,
    DeletePluginMutationVariables
  >,
) {
  const options = { ...defaultOptions, ...baseOptions };
  return Apollo.useMutation<
    DeletePluginMutation,
    DeletePluginMutationVariables
  >(DeletePluginDocument, options);
}
export type DeletePluginMutationHookResult = ReturnType<
  typeof useDeletePluginMutation
>;
export type DeletePluginMutationResult =
  Apollo.MutationResult<DeletePluginMutation>;
export type DeletePluginMutationOptions = Apollo.BaseMutationOptions<
  DeletePluginMutation,
  DeletePluginMutationVariables
>;
